/* *
 * This module is a small abstraction over
 * window.postMessage and window.addEventListener('message', ... )
 * to make sure messages are only send & listened from remind domains.
 *
 */
import Config from 'Config';

const DOMAIN = Config.Environment.R101_FRONTEND_URL;

let doIsTrusted = true;

function send(message: string, target: any): void {
  target.postMessage(message, DOMAIN);
}

function removeIsTrusted() {
  doIsTrusted = false;
}

function isSafe(message: MessageEvent) {
  if (doIsTrusted) {
    return message.isTrusted && message.origin === DOMAIN;
  } else {
    return message.origin === DOMAIN;
  }
}

type listenCB = (source: any) => void;

type listener = (
  message: string,
  cb: listenCB
) => {
  unlisten: () => void;
};

const listen: listener = (message, cb) => {
  const handler = (event: MessageEvent) => {
    if (isSafe(event) && event.data === message) {
      cb(event.source);
    }
  };

  window.addEventListener('message', handler, false);

  return {
    unlisten: () => window.removeEventListener('message', handler),
  };
};

export { listen, send, removeIsTrusted };
